/**
 * 用 MyDatePicker / useDatePicker2 的区间驱动 GET /troas/:id（传 startDate、endDate，YYYYMMDD 数字）。
 * 不传 maxDay，由服务端默认（当前 360）。
 *
 * 返回 {} 时请求不带安装日参数，服务端会按 resolveTroasDetailScope 使用默认窗口（与日期选择器可能不一致）。
 * useDatePicker2 初始化即带合法 YYYYMMDD，正常不应出现 {}。
 */
export function troasQueryFromPicker(startDate, endDate) {
  if (startDate == null || endDate == null) return {}
  const s = normalizeYmdDigits(startDate)
  const e = normalizeYmdDigits(endDate)
  if (!s || !e) return {}
  return {
    startDate: Number(s),
    endDate: Number(e),
  }
}

/** 仅接受至少 8 位连续数字（去非数字后取前 8 位），与 useDatePicker2 的 YYYYMMDD 一致 */
function normalizeYmdDigits(v) {
  const digits = String(v).replace(/\D/g, '')
  if (digits.length < 8) return null
  return digits.slice(0, 8)
}
